<template>
  <div
    ref="wfSelect"
    class="tail-select w-full hide-selected hide-disabled multiple"
    :class="{ 'opacity-60': disabled, active: show }"
  >
    <div class="select-label tail-select-container" @click.stop="showList">
      <span class="label-inner" v-if="!selected.title">-- Select --</span>
      <div v-else class="" data-group="#">
        <button
          class="bg-gray-500 text-white px-1  rounded-full text-xs"
          @click.prevent="clearSelected"
          v-show="props.showBtnClear"
        >
          X
        </button>
        {{ selected.title }}
      </div>
    </div>

    <div
      class="select-dropdown relative"
      style="max-height 348px; height: auto; display: block; overflow: visible;"
      v-show="show"
    >
      <div class="dropdown-search">
        <input
          type="text"
          autofocus
          ref="searchInputRef"
          v-model="searchInput"
          @keydown.esc="searchClear"
          class="search-input"
          placeholder="Type in serach... 3 charactor"
        />
      </div>
      <div class="dropdown-inner">
        <ul class="dropdown-optgroup relative" style="max-height: 300px;">
          <li
            class="dropdown-option"
            v-for="item in items"
            :key="item.employee_id"
            @click="handleSelected(item)"
            v-show="hideSelected(item.employee_id)"
          >
            {{ item.fullname_th }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  computed,
  onMounted,
  onUpdated,
  watch
} from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  props: {
    modelKey: {
      type: String
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    modelValue: {
      type: String,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    showBtnClear: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, context) {
    const store = useStore()
    store.dispatch('global/loadEmployee')
    const employeeOption = computed(() => store.state.global.employee)
    const show = ref(false)
    const searchInput = ref(null)
    const searchInputRef = ref(null)
    const showList = async () => {
      if (props.disabled) return

      show.value = !show.value
      searchInput.value = ''
    }

    onUpdated(() => {
      searchInputRef.value.focus()
    })

    const items = computed(() => {
      if (searchInput.value) {
        if (searchInput.value.length >= props.options.searchMinLength) {
          return employeeOption.value.filter(item => {
            return item.fullname_th.includes(searchInput.value)
          })
        } else {
          return []
        }
      } else {
        return employeeOption.value.filter((item, inx) => {
          return item.wf_level >= 10
        })
      }
    })

    const itemSelected = reactive([])
    const selected = reactive({
      title: '',
      value: null
    })
    const init = async () => {
      const emp = await employeeOption.value.find(item => {
        return item.employee_id == props.modelValue
      })
      // console.log('emp: ', emp, props.modelValue)
      if (emp) {
        selected.title = emp.fullname_th
        selected.value = emp.employee_id

        store.commit('global/setEmployeeDefault', emp)
      }
    }
    const handleSelected = item => {
      // console.log('item: ', item)
      selected.title = item.fullname_th
      selected.value = item.employee_id
      context.emit('update:modelValue', item.employee_id)
      store.commit('global/setEmployeeDefault', item)
      context.emit('change', {
        target: 'select-single-employee',
        value: item.employee_id
      })
      showList()
    }
    const hideSelected = id => {
      const test = itemSelected.filter(item => item.employee_id === id)
      return test.length !== 1
    }
    const searchClear = () => {
      searchInput.value = ''
    }

    const clearSelected = () => {
      selected.title = ''
      selected.value = null
      show.value = true
      context.emit('update:modelValue', null)
    }

    const oneAgain = ref(true)
    watch(
      () => props.modelValue,
      (newVal, oldVal) => {
        if (newVal != oldVal && oneAgain.value) {
          init()
          oneAgain.value = false
        }
      }
    )

    watch(employeeOption, (newVal, oldVal) => {
      setTimeout(() => init(), 1000)
    })

    onMounted(() => {
      init()
    })
    return {
      props,
      show,
      showList,
      searchInput,
      searchInputRef,
      items,
      itemSelected,
      handleSelected,
      hideSelected,
      searchClear,
      selected,
      employeeOption,
      clearSelected
      //   wfSelect
    }
  }
})
</script>
